import { useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import { useFilters } from "../../../../utils/hooks/useFilters";
import { usePermissions } from "../hooks/usePermissions";
import useApi from "../../../../utils/api";
import { formatTimeSheetParams } from "../../../TimeSheet/api/helpers";

export const useCountUnpublishedQuery = () => {
    const { type, dispatch } = useScheduleContext();
    const { canCreate } = usePermissions();
    const [filters] = useFilters();
    const { authGet } = useApi();

    const params = useMemo(() => {
        const _params: any = {
            ...formatTimeSheetParams({
                filters: filters?.filters || [],
                from: filters?.mode === "month" ? moment(filters?.from).startOf("week").format("YYYY-MM-DD") : filters?.from,
                to: filters?.mode === "month" ? moment(filters?.to).endOf("week").format("YYYY-MM-DD") : filters?.to
            }),
            sort: filters?.sort
        }
        if (filters?.mode !== "month") {
            _params.pageIndex = Number(filters?.page || 1) - 1;
            _params.pageSize = Number(filters?.pageSize || 50);
        }
        return _params;
    }, [filters]);

    const queryCount = useQuery({
        queryKey: [
            type === "team" ? "/schedules/v2/count-unpublished" : "/my/schedules/v2/count-unsubmitted",
            params
        ],
        queryFn: ({ queryKey }) => {
            const [url, params] = queryKey;
            return authGet(url, { params });
        },
        enabled: ["team", "home"].includes(type) && canCreate
    });

    useEffect(() => {
        if (!queryCount.isLoading) {
            dispatch({
                type: "set-count",
                payload: { count: queryCount.data || 0 }
            });

            dispatch({
                type: "set-reset-count",
                payload: { resetCount: queryCount.refetch }
            });
        }
    }, [queryCount.isLoading, queryCount.data, dispatch, queryCount.refetch]);

    return undefined;
}
